const endpoints = {
	getSystemModules: 'project_modules/getSystemModules',
	getProjects: 'project_modules/getProjects',
	setProjectModules: 'project_modules/setProjectModules',
	getJobTypeDefaults: 'job_types/getDefaults',
	updateJobTypeDefaults: 'job_types/updateDefaults'
}
export {endpoints}